import { Select } from 'antd';
import { useTranslation } from 'react-i18next';
import Widget from '../../../../../../Analysis/widget';
import { useState } from 'react';
import { filterOptions } from './config';
import IncidentsTimeline from './components/incidents-timeline';
import TerritorialDistribution, { distributionColors } from './components/territorial-distribution';
import ProblemSolvers, { solversColors } from './components/problem-solvers';
import { useCallback } from 'react';
import { DashboardService } from '../../../../../../../services';
import { useEffect } from 'react';

export default function RisksWidget({
  type = 'conflict',
  title = 'Conflict Overview',
  partners = [],
  category = 'conflict',
  selectedParters = [],
  loading: partnersLoading = false,
}) {
  const { t } = useTranslation();
  const [filter, setFilter] = useState(filterOptions[0].value);
  const [data, setData] = useState({
    events: [],
    distribution: [],
    solvers: [],
  });
  const [loading, setLoading] = useState(true);

  const fetchData = useCallback(async () => {
    if (partnersLoading) {
      return;
    }

    setLoading(true);

    try {
      const { data } = await DashboardService.getTimeline(selectedParters, type, filter);
      const { data: solversData } = await DashboardService.getSolvers(selectedParters, type, filter);
      const { data: distributionData } = await DashboardService.getDistribution(selectedParters, type, filter);

      const events = [];
      let distribution = [];
      let solvers = [];

      Object.keys(data).forEach((key) => {
        const val = data[key];
        events.push(...val.map((v) => ({
          ...v,
          incidentSeverity: v.severity,
          typeOfEvent: v.severity ? 'incident' : 'riskMitigationMeasures',
          type: v.severity ? 'Incident' : 'Risk Mitigation Action',
          source: partners.find((p) => p.id === v.source)?.nickName || 'Own Data',
        })))
      })

      let totalDistributions = 0;

      Object.keys(distributionData).forEach((key, i) => {
        const { events, locationData } = distributionData[key];
        const val = events?.length || 0;
        totalDistributions += val;
        distribution.push({ name: key, incidents: val, color: distributionColors[i] || '#82B88A', locationData });
      })

      distribution = distribution.map((d) => ({
        ...d,
        percent: d.incidents / totalDistributions,
      }));

      let totalSolvers = 0;

      Object.keys(solversData).forEach((key, i) => {
        const { actions, implementerData } = solversData[key];
        const val = actions?.length || 0;
        totalSolvers += val;
        solvers.push({ name: key, actions: val, color: solversColors[i] || '#D9E9DC', implementerData });
      })

      solvers = solvers.map((d) => ({
        ...d,
        percent: d.actions / totalSolvers,
      }));

      setData({ events, solvers, distribution });
    } catch (err) {
      console.log(err);
    }

    setLoading(false);
  }, [selectedParters, filter, partnersLoading]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <Widget
      title={t(title)}
      className="with-border-header month-select-header"
      header={(
        <>
          <div className="flex-1" />
          <div>
            <Select
              value={filter}
              className='custom-select white month-select'
              onChange={(val) => setFilter(val)}
            >
              {filterOptions.map((o) => (
                <Select.Option value={o.value} key={o.value}>
                  {t(o.label)}
                </Select.Option>
              ))}
            </Select>
          </div>
        </>
      )}
    >
      <div className="flex flex-row flex-col-mobile gap-6">
        <IncidentsTimeline
          filter={filter}
          data={data.events}
          loading={loading || partnersLoading}
        />
        <TerritorialDistribution
          category={category}
          data={data.distribution}
          loading={loading || partnersLoading}
        />
        <ProblemSolvers
          data={data.solvers}
          loading={loading || partnersLoading}
        />
      </div>
    </Widget>
  );
}
